import {Button} from '@sportcast/ui-react';
import {Image, Modal} from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import sportcastLogo from '../../assets/SportcastLogoDataPrivacy.png';
import {RootState} from '../../store';
import LegalHintsText from '../common/legal-infos/LegalHintsText';
import './DataPrivacyAcceptanceModal.scss';

interface LegalHintsModalProps {
    show: boolean;
    onClose: () => void;
}

const LegalHintsModal = (props: LegalHintsModalProps) => {
    const [t] = useTranslation();
    const userIsRePortUser = useSelector((state: RootState) => !!state.login.userData?.role);

    return (
        <Modal show={props.show} className="data-privacy-modal" onHide={props.onClose}>
            <Modal.Header closeButton={!userIsRePortUser}>
                <div className="data-privacy-headline">
                    <b>Datenschutzerklärung und Cookie-Richtlinie für das RePort-Portal der Sportcast</b>
                    <p>
                        <Image src={sportcastLogo} height={'75px'} width={'75px'} alt="Sportcast"/>
                    </p>
                </div>

            </Modal.Header>
            <Modal.Body>
                <LegalHintsText/>
            </Modal.Body>
            {
                userIsRePortUser &&
                <Modal.Footer className="data-privacy-footer">
                    <Button
                        id="close-data-privacy-modal"
                        className="float-end"
                        label={t('button.CLOSE')}
                        onClick={props.onClose}/>
                </Modal.Footer>
            }
        </Modal>
    );
};
export default LegalHintsModal;
